import React from 'react'
import styled from 'styled-components'
import { PageProps } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'
import Providers, { Config } from 'components/layout/Providers'

import { ContentContainer, Main, Nav, Footer, Layout } from 'components/layout'
import {
  ActionButton,
  RichText,
  FormLabel,
  FormTextInput,
  FormTextArea,
} from 'components/ui'
import useContactPageData from 'cmsHooks/useContactPageData'
import EmailerForm from '../../EmailerForm'

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    max-width: 800px;
    color: ${({ theme }) => theme.text};
  }
  form {
    width: 100%;
    max-width: 800px;
    color: ${({ theme }) => theme.text};
  }
`
const Para = styled.p`
  font-size: 22px;
  margin-top: 20px;
  line-height: 1.4em;
  text-align: center;

  &:last-of-type {
    margin-bottom: 40px;
  }
`
const CharCount = styled.p`
  font-size: 16px;
  margin-bottom: 50px;
`
const Spacer = styled.div`
  height: 100px;
`
const NameFields = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  > div {
    flex-basis: 45%;
  }
`
const FormRow = styled.div`
  margin-bottom: 30px;
`

const Contact = ({ pageContext }: PageProps) => {
  const data = useContactPageData()

  // cast pageContext to correct type
  const config = pageContext as Config

  return (
    <Providers config={config}>
      <Layout>
        {/* TODO: get SEO title from Airtable */}
        <CMS.SEO title={'Contact'} />
        <Nav />
        <Main>
          <ContentContainer>
            <FlexContainer>
              <h1>
                <CMS.Text name="First header" data={data} />
              </h1>
              <Para>
                <CMS.Text name="Paragraph text" data={data} />
              </Para>
              <EmailerForm
                {...{
                  subjectCMSName: 'Contact subject',
                  siteCMSName: 'Site name',
                  bodyCMSName: 'Contact body',
                  buttonTextCMSName: 'Contact button text',
                  submittingButtonTextCMSName: 'In-progress button text',
                  successMessageCMSName: 'Contact success text',
                  errorMessageCMSName: 'Error text',
                  submitUrlCMSName: 'Submit URL',
                  formAriaLabelCMSName: 'Contact aria label',
                }}
              >
                <FormRow>
                  <NameFields>
                    <div>
                      <FormLabel>
                        <CMS.Text name="First name field label" data={data} />
                        <FormTextInput type="text" name="First name" required />
                      </FormLabel>
                    </div>
                    <div>
                      <FormLabel>
                        <CMS.Text name="Last name field label" data={data} />
                        <FormTextInput type="text" name="Last name" required />
                      </FormLabel>
                    </div>
                  </NameFields>
                </FormRow>
                <FormRow>
                  <FormLabel>
                    <CMS.Text name="Email field label" data={data} />
                    <FormTextInput type="email" name="Email" required />
                  </FormLabel>
                </FormRow>
                <FormRow>
                  <FormLabel>
                    <CMS.Text name="Organization field label" data={data} />
                    <FormTextInput type="text" name="Organization" />
                  </FormLabel>
                </FormRow>
                <FormLabel>
                  <CMS.Text name="Comment field label" data={data} />
                  <FormTextArea
                    name="Comment or question"
                    maxLength={parseInt(CMS.getText(data, 'Text limit')) || 500}
                    required
                  />
                </FormLabel>
                <FormRow>
                  <CharCount>
                    {parseInt(CMS.getText(data, 'Text limit')) ? (
                      <CMS.Text name="Text limit" data={data} />
                    ) : (
                      '500'
                    )}{' '}
                    characters
                  </CharCount>
                </FormRow>
              </EmailerForm>
            </FlexContainer>
          </ContentContainer>
        </Main>
        <Footer />
      </Layout>
    </Providers>
  )
}

export default Contact
